/* global wp_admin_ajax */

import AjaxUtils from './utils/ajax';

export default function initBlockDocumentation() {
    if (document.querySelector('.documentation.block')) {
        new BlockDocumentation(document.querySelector('.documentation.block'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class BlockDocumentation {
    constructor($el) {
        this.$el = $el;
        this.$form = $el.querySelector('.js-form-search');
        this.$formInputSearch = this.$form.querySelector('.js-search');
        this.$formInputHiddenOrder = this.$form.querySelector('input[name="order"]');
        this.$btnsOrder = this.$el.querySelectorAll('.js-sort');
        this.$searchResults = this.$form.querySelector('.js-resultats');
        this.$btnFilterOpenModal = this.$form.querySelector('.js-btn-open-filters-modal');
        this.$btnFilterCloseModal = this.$form.querySelector('.js-btn-close-filters-modal');
        this.$filtresDocumentationMobileWrapper = document.querySelector('.js-filtres-documentation-mobile-wrapper');
        this.$btnApply = this.$form.querySelector('.btn-apply');
        this.$filters = this.$form.querySelector('.filtres');
        this.initTabs();
        this.initForm();
        // Permet de gérer le cas où on arrive sur la liste des documents depuis une notification
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const mode = (urlParams.get('typologie') && urlParams.get('documentation_categorie') ? 'filter' : 'submit');
        
        this.filterList(mode);
    }

    initTabs() {
        // Tabs
        const tabs = this.$el.querySelectorAll('.js-documentation-tabs');
        const tabsContent = this.$el.querySelectorAll('.content-tabs .tab');
        let currentTab = this.$el.querySelector('.js-documentation-tabs.active');
        let currentTabContent = this.$el.querySelector('.content-tabs .tab.active');
    
        tabs.forEach(tab => {
            tab.addEventListener('click', (evt) => {
                evt.preventDefault();
                currentTab.classList.remove('active');
                evt.target.classList.add('active');
                currentTab = evt.target;
                
                tabsContent.forEach(tabContent => {
                    if (tabContent.dataset.jsTypologie === currentTab.dataset.jsTypologie) {
                        currentTabContent.classList.remove('active');
                        tabContent.classList.add('active');
                        currentTabContent = tabContent;
                        
                        this.$form.querySelectorAll('input[type="checkbox"]').forEach(ele => {
                            ele.checked = false;
                        });

                        this.$formInputSearch.value = '';

                        this.filterList('submit');
                    }
                });
            });
        });

        this.$btnsOrder.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (evt.target.dataset.order === 'DESC') {
                    evt.target.dataset.order = 'ASC';
                } else {
                    evt.target.dataset.order = 'DESC';
                }
                this.$formInputHiddenOrder.value = evt.target.dataset.order;
                this.filterList('filter');
            });
        });
    }

    initForm() {
        this.$form.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.filterList('submit');
        });

        this.$form.querySelectorAll('input[type="checkbox"]').forEach(ele => {
            ele.addEventListener('change', (evt) => {
                if (!this.$filters.classList.contains('open')) {
                    this.filterList('filter');
                }
            });
        });

        this.$btnFilterOpenModal.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$filtresDocumentationMobileWrapper.append(this.$filters);
            this.$filtresDocumentationMobileWrapper.classList.add('visible');
            document.querySelector('body').classList.toggle('noscroll');
        });

        this.$btnFilterCloseModal.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$filtresDocumentationMobileWrapper.classList.remove('visible');
            this.$btnFilterOpenModal.after(this.$filters);
            document.querySelector('body').classList.toggle('noscroll');
        });

        this.$btnApply.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$btnFilterCloseModal.click();
            this.filterList('filter');
        });
    }

    filterList(mode) {
        const args = new FormData(this.$form);
        args.append('action', 'search_posts');
        args.append('post_type', 'documentation');
        args.append('typologie', this.$el.querySelector('.content-tabs .tab.active').dataset.jsTypologie);
        
        AjaxUtils.postData(wp_admin_ajax, args).then(response => {
            if (response.success) {
                if (response.data.nb_results) {
                    this.$searchResults.classList.remove('visible');

                    this.$el.querySelector('.content-tabs .tab.active').innerHTML = response.data.html;
                    
                    if (mode === 'submit') {
                        this.$form.querySelectorAll('input[type="checkbox"]').forEach(ele => {
                            const nbElePerCat = this.$el.querySelector('.content-tabs .tab.active').querySelectorAll('[data-categorie="' + ele.value + '"]').length;
                            if (!nbElePerCat) {
                                ele.disabled = true;
                                ele.parentNode.classList.add('disabled');
                            } else {
                                ele.disabled = false;
                                ele.parentNode.classList.remove('disabled');
                            }
                        });
                    }
                } else {
                    this.$searchResults.classList.add('visible');
                    const searchResults = this.$searchResults;
                    setTimeout(function() {
                        searchResults.classList.remove('visible');
                    }, 2000);
                }
            }
        });
    }
}
